<template>
  <div>
    <el-tooltip  effect="light" placement="top">
      <div slot="content" class="tip_con" >{{title}}</div>
      <div class="title ellipsis"> {{ title }}</div>
    </el-tooltip>
    <span class="account ellipsis2" v-html="desc"></span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: [String, Number],
    },
    desc: {
      type: [String],
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  watch: {},
};
</script>
<style scoped>
.account {
  font-size: 0.2rem;
  color: #929dad;
  word-break: break-all;
}
.title {
  display: inline-block;
  max-width: 100%;
  font-size: 0.28rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0.1rem;
}
</style>
